import { render } from "./LitigationDetailWindow.vue?vue&type=template&id=745542e4&scoped=true"
import script from "./LitigationDetailWindow.vue?vue&type=script&lang=js"
export * from "./LitigationDetailWindow.vue?vue&type=script&lang=js"

import "./LitigationDetailWindow.vue?vue&type=style&index=0&id=745542e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745542e4"]])

export default __exports__